import React, { useCallback } from 'react';
import 'components/DogCard/DogCard.css';
import DogAvatar from 'components/DogAvatar/DogAvatar';
import { useHistory } from 'react-router-dom';
import Button from 'components/Button/Button';

function DogCard({ dogRef, id, onClick }) {
    let history = useHistory();
    const { avatarImage , description, name, price } = dogRef?.data() || {};
    const {src: avatarUri} = avatarImage || {}
    const clickHandler = useCallback(() => {
        if (onClick) return onClick(id);
        history.push(`dogDetail/${id}`);
    }, [history, id, onClick]);

    return (
        <div className={'dog-card'} onClick={clickHandler}>
            <DogAvatar className={'dog-card__avatar'} avatarUri={avatarUri} />
            <div className={'dog-card__info shadow'} data-aos="fade-up">
                <div className={'dog-card__description'}>
                    <h3 className={'dog-card__name'}>{name}</h3>
                    {price && <h3 className={'dog-card__name'}>$ {price}</h3>}
                    <p className={'dog-card__text'}>{description}</p>
                </div>
                <Button className={'dog-card__button'} label={'View Details'} />
            </div>
        </div>
    );
}

export default DogCard;
